<template>
  <v-fade-transition slot="append">
    <v-list-tile class="custom-height"><hr></v-list-tile>
  </v-fade-transition>
</template>

<script>
export default {
  name: 'DividerLineElement'
}
</script>

<style scoped>
.custom-height {
  height: 10px !important;
}
hr {
  border: none;
  border-bottom: 1px solid hsla(200, 10%, 60%, 100);
  height: 15px;
  width: 100px;
  margin: -50px -20px 0 -20px;
}
</style>
